module.exports = __webpack_public_path__ + "img/gb6186.prt.b8b25164.jpg";